import { LiveAnnouncer } from "@angular/cdk/a11y";
import { ChangeDetectionStrategy, Component, inject, OnInit, output } from "@angular/core";
import { BiTranslateDirective, BiTranslatePipe, BiTranslateService } from "@globals/bi-translate";
import { AddressSelectedEvent } from "@globals/components/zip-street-number-input/AddressSelectedEvent";
import ZipStreetNumberInputComponent from "@globals/components/zip-street-number-input/zip-street-number-input.component";
import { BiCountryId } from "@globals/enums/BiLanguageAndCountryId";
import { AddressModel } from "@globals/openapi-models/model/addressModel";
import { BiSkipLinkComponent } from "@iframeModulesShared/components/bi-skip-link/bi-skip-link.component";
import { UntilDestroy } from "@ngneat/until-destroy";
import { ButtonModule } from "primeng/button";
import { SubscriptionModuleSharedService } from "../subscription-module-shared.service";
export type CreateSubscriptionEventData = {
  subscriptionData: AddressModel;
  /**
   * Needed for handling accessiblity
   */
  targetButton: HTMLButtonElement;
};

@UntilDestroy()
@Component({
  selector: "create-address-subscription",
  templateUrl: "./create-address-subscription.component.html",
  styles: [":host {position: relative;vertical-align: top; padding-left: .5em;padding-right: .5em;}"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BiTranslateDirective, BiTranslatePipe, BiSkipLinkComponent, ZipStreetNumberInputComponent, ButtonModule],
  host: {
    "[cdkTrapFocus]": "true"
  }
})
export class CreateAddressSubscriptionComponent implements OnInit {
  onCreateSubscription = output<CreateSubscriptionEventData>();

  onBack = output();

  constructor(public sharedService: SubscriptionModuleSharedService) {
    const announcer = inject(LiveAnnouncer);
    announcer.clear();
    announcer.announce(inject(BiTranslateService).instant("iFrame.Subscription.EnterAddrInfo"));
  }

  public countryId: BiCountryId;

  public ngOnInit() {
    this.countryId = this.sharedService.countryId;
  }

  public onAddressSelected(event: AddressSelectedEvent) {
    this.onCreateSubscription.emit({ subscriptionData: event.address, targetButton: event.targetButton });
  }
}
